import React from "react";
import { CheckCircle } from "lucide-react";
import BagsImage from "./Images/ab3.jpg"; // replace with your first image
import ShoppingImage from "./Images/ab2.jpg"; // replace with your second image

const HistorySection = () => {
  const points = [
    "Humble Beginnings",
    "Milestones & Achievements",
    "Building a Legacy of Trust",
    "Shaping the Future, Rooted in the Past",
  ];

  return (
    <div className="bg-white py-16 px-6 md:px-16 lg:px-24">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        {/* Left Side Images */}
        <div className="relative">
          {/* Background Image */}
          <img
            src={BagsImage}
            alt="Bags"
            className="rounded-xl shadow-lg"
          />

          {/* Overlay Image */}
          <img
            src={ShoppingImage}
            alt="Shopping"
            className="absolute top-12 left-12 w-3/4 rounded-xl shadow-lg border-4 border-white"
          />
        </div>

        {/* Right Side Content */}
        <div>
          <h2 className="text-3xl md:text-4xl font-bold text-green-900 mb-6">
            Our History
          </h2>
          <p className="text-gray-700 mb-6 leading-relaxed">
            Daily Go began as a small effort to connect suppliers and
            businesses, and has grown into a trusted wholesale grocery platform
            for retailers, restaurants, and institutions. We cater to every
            need—whether bulk supplies, large-scale orders, or smaller
            requirements. Driven by a commitment to efficiency, quality, and
            service, we've expanded our reach, partnerships, and logistics. Our
            journey is defined by the trust we’ve built and the value we deliver
            every day.
          </p>

          <ul className="space-y-4">
            {points.map((point, index) => (
              <li
                key={index}
                className="flex items-center gap-3 text-gray-800 font-medium"
              >
                <CheckCircle className="w-6 h-6 text-green-700" />
                {point}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default HistorySection;
